import React, { useEffect, useState } from "react"
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap"
import { get, map } from "lodash"
import { withTranslation } from "react-i18next"

//i18n

import currencies from "common/currencies"

const CurrencyDropdown = () => {
  // Declare a new state variable, which we'll call "menu"
  const [selectedCurerency, setSelectedCurrency] = useState("")
  const [menu, setMenu] = useState(false)

  useEffect(() => {
    const currentLanguage = localStorage.getItem("MAZAYA_CURRENCY")
    setSelectedCurrency(currentLanguage)
  }, [])

  const changeLanguageAction = lang => {
    //set language as i18n
    if (selectedCurerency) window.location.reload()
    localStorage.setItem("MAZAYA_CURRENCY", lang)
    setSelectedCurrency(lang)
  }

  const toggle = () => {
    setMenu(!menu)
  }

  return (
    <>
      <Dropdown isOpen={menu} toggle={toggle} className="d-inline-block">
        <DropdownToggle
          className="btn header-item d-flex align-items-center"
          tag="button"
        >
          <div style={{ fontSize: "18px", fontWeight: "bold" }}>
            {get(currencies, `${selectedCurerency}.label`)}
          </div>
        </DropdownToggle>

        <DropdownMenu className="language-switch dropdown-menu-end">
          {map(Object.keys(currencies), key => (
            <DropdownItem
              key={key}
              onClick={() => changeLanguageAction(key)}
              className={`notify-item ${
                selectedCurerency === key ? "active" : "none"
              }`}
            >
              <img
                src={get(currencies, `${key}.flag`)}
                alt="Skote"
                className="me-1"
                height="12"
              />
              <span className="align-middle">
                {get(currencies, `${key}.label`)}
              </span>
            </DropdownItem>
          ))}
        </DropdownMenu>
      </Dropdown>
    </>
  )
}

export default withTranslation()(CurrencyDropdown)
